import { useEffect, useState } from "react";
import { PieChart } from '@mui/x-charts/PieChart';
import { WorkerStatusCard } from '../assets/style'
import { Box, Typography, Button, Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material';
import { useLazyGetTodayAlertCountQuery, useLazyGetThisWeekAlertCountQuery, useLazyGetThisMonthAlertCountQuery } from '../features/dashboard/DashboardSlice'
import { useTranslation } from "react-i18next";

function AlertPieChart(props: { data?: any }) {

    const { data } = props;
    const [buttonA, setButtonA] = useState("#407cb3");
    const [buttonB, setButtonB] = useState("#c5c6c7");
    const [buttonC, setButtonC] = useState("#c5c6c7");
    const [getTodayAlertCount, todayAlert] = useLazyGetTodayAlertCountQuery();
    const [getThisWeekAlertCount, thisWeekAlert] = useLazyGetThisWeekAlertCountQuery();
    const [getThisMonthAlertCount, thisMonthAlert] = useLazyGetThisMonthAlertCountQuery();
    const {t, i18n} = useTranslation();

    /*
    const defaultData = [
        { alert: "Gas Level", num: 8 },
        { alert: "Environmental", num: 6 },
        { alert: "Equipment", num: 5 },
        { alert: "Emergency", num: 4 },
        { alert: "Procedural", num: 3 },
        { alert: "Personal Safety", num: 3 },
        { alert: "Operational", num: 2 },
        { alert: "Weather", num: 1 }];

    const thisWeekData = [
        { alert: "Gas Level", num: 53 },
        { alert: "Environmental", num: 67 },
        { alert: "Equipment", num: 21 },
        { alert: "Emergency", num: 43 },
        { alert: "Procedural", num: 22 },
        { alert: "Personal Safety", num: 23 },
        { alert: "Operational", num: 41 },
        { alert: "Weather", num: 5 },
        { alert: "Other", num: 9 }];
    */

    const [dataArray, setDataArray] = useState([{ name: "", count: 0 }]);
    const count = dataArray?.length;

    function processAlertData(data: any[]) {
        const names = data.map(item => item.name);
        const result = [...data];
        if (!names.includes("Detect worker having high heart rate")) {
            result.push({ name: "Detect worker having high heart rate", count: 0 });
        }
        if (!names.includes("Detect worker having high body temperature")) {
            result.push({ name: "Detect worker having high body temperature", count: 0 });
        }
        if (!names.includes("Detect worker having no motion")) {
            result.push({ name: "Detect worker having no motion", count: 0 });
        }
        return result;
    }

    useEffect(() => {
        Promise.all([getTodayAlertCount(), getThisWeekAlertCount(), getThisMonthAlertCount()])
            .then(([todayRes, weekRes, monthRes]) => {
                if (todayRes.status == 'fulfilled') {
                    setDataArray(processAlertData(todayRes?.data));
                }
            })
        //if (!(data == null || data == undefined)) {
        //    setDataArray(data);
        //}
    }, [])

    useEffect(() => {
        if (count > 0) {
            generateRows(count);
        }
    }, [dataArray])

    const handleButtonClickA = () => {
        setButtonB('#c5c6c7');
        setButtonA('#407cb3');
        setButtonC('#c5c6c7');
        setDataArray(processAlertData(todayAlert?.data));
    };

    const handleButtonClickB = () => {
        setButtonA('#c5c6c7');
        setButtonB('#407cb3');
        setButtonC('#c5c6c7');
        setDataArray(processAlertData(thisWeekAlert?.data));
    };

    const handleButtonClickC = () => {
        setButtonA('#c5c6c7');
        setButtonB('#c5c6c7');
        setButtonC('#407cb3');
        setDataArray(processAlertData(thisMonthAlert?.data));
    };

    const generateRows = (count: number) => {
        const rows = [];
        const defaultColor = ["#27ebf2", "#2775f2", "#f2f227", "#27f2b5", "#2a27f2", "#8927f2", "#27f253", "#f28927", "#f227b2", "#f22738"];
        for (let i = 0; i < count; i++) {
            rows.push({ id: i, color: Pinball(defaultColor[i % defaultColor.length]), alert: dataArray[i].name, num: dataArray[i]?.count, colorMark: defaultColor[i % defaultColor.length] });
        }
        return rows;
    };

    const Pinball = (color: any) => {
        return <span style={{ display: "inline-block", width: "10px", height: "10px", borderRadius: "2px", backgroundColor: `${color}` }}></span>
    };

    return (
        <>
            <WorkerStatusCard sx={{ minHeight: '300px', maxHeight: '500px', "@media (max-width: 800px)": { maxHeight: '100%' } }}>
                <Box sx={{ display: "flex", alignContent: "center", height: "100%", "@media (max-width: 800px)": { justifyContent: "center", justifyItems: "center", alignItems: "center", marginLeft: "0px", flexDirection: "column" } }}>
                    <Box sx={{ display: "flex", flexDirection: "column", height: "100%", width: "60%", "@media (max-width: 800px)": { order: 0, width: "100%" } }}>
                        <Box sx={{ float: "left", marginTop: "10px", marginLeft: "15px", width: "100%", height: "10%" }}>
                            {<Typography variant="h6" style={{ color: "#193057" }}>{t("Alert")}</Typography>}
                        </Box>
                        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%", "@media (max-width: 800px)": { marginRight: "-80px" } }}>
                            <PieChart
                                series={[
                                    {
                                        data: generateRows(count).map((row) => ({
                                            id: row.id,
                                            label: t(row.alert),
                                            value: row.num,
                                            color: row.colorMark
                                        })),
                                        highlightScope: { faded: 'global', highlighted: 'item' },
                                        faded: { innerRadius: 20, additionalRadius: -20, color: 'gray' },
                                        innerRadius: 0,
                                        outerRadius: 120,
                                        paddingAngle: 1,
                                        cornerRadius: 5
                                    },
                                ]}
                                slotProps={{
                                    legend: { hidden: true },
                                }}
                                width={300}
                                height={400}
                            />
                        </Box>
                    </Box>
                    <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center">
                        {/* {!dataArray && <Typography variant="h6" noWrap>{t("No Alert")}</Typography>} */}
                    </Box>

                    <Box sx={{ width: "40%", marginTop: "30px", marginRight: "40px", "@media (max-width: 800px)": { order: 1, width: "90%", marginRight: "0px", marginTop: "0px" } }}>
                        <Box sx={{ display: "flex", justifyContent: "end", marginRight: "0px", marginBottom: "10px" }}>
                            <Button variant='contained' style={{ backgroundColor: buttonA, marginRight: "20px" }} onClick={handleButtonClickA}>{t("Today")}</Button>
                            <Button variant='contained' style={{ backgroundColor: buttonB, marginRight: "20px" }} onClick={handleButtonClickB}>{t("This Week")}</Button>
                            <Button variant='contained' style={{ backgroundColor: buttonC }} onClick={handleButtonClickC}>{t("This Month")}</Button>
                        </Box>
                        <Box>
                            <TableContainer>
                                <Table sx={{ minWidth: 100, maxHeight: "100px" }} size='small' aria-label="simple table">
                                    <TableBody sx={{ '& .MuiTableCell-root': { borderBottom: "none" } }}>
                                        {generateRows(count).map((row) => (
                                            <TableRow key={row.alert} sx={{ ',&:last-child td, &:last-child th': { borderLeft: 0, borderRight: 0, borderBottom: 4, borderColor: "#ffffff", backgroundColor: "#d7ebfa", height: "40px" } }}>
                                                <TableCell align="right">
                                                    {row.color}
                                                </TableCell>
                                                <TableCell component="th" scope="row">{t(row.alert)}</TableCell>
                                                <TableCell align="left">{row.num}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                    </Box>
                </Box>
            </WorkerStatusCard>
        </>
    );
}

export default AlertPieChart;